import { render } from "./Extranet.vue?vue&type=template&id=912b9cbc"
import script from "./Extranet.vue?vue&type=script&lang=js"
export * from "./Extranet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__